import { createSlice, configureStore } from "@reduxjs/toolkit";

/* =====================================================
   AUTH / LOGIN SLICE
===================================================== */

const authInitialState = {
  logged: false,
  uid: null,
  role: null,
};

const loginSlice = createSlice({
  name: "login",
  initialState: authInitialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.logged = true;
      state.uid = action.payload.uid;
      state.role = action.payload.role;
    },
    logout: () => authInitialState,
  },
});

/* =====================================================
   TEACHER SLICE
===================================================== */

const teacherInitialState = {
  data: null,
  loading: false,
  error: null,
  profileImage: null,
  certificates: [],
};

const teacherSlice = createSlice({
  name: "teacher",
  initialState: teacherInitialState,
  reducers: {
    setTeacherData: (state, action) => {
      state.data = action.payload;
      state.profileImage = action.payload?.profileImage || null;
      state.loading = false;
    },
    setTeacherLoading: (state) => {
      state.loading = true;
    },
    setTeacherError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    setProfileImage: (state, action) => {
      state.profileImage = action.payload;
      if (state.data) {
        state.data.profileImage = action.payload;
      }
    },
    setCertificates: (state, action) => {
      state.certificates = action.payload;
    },
    clearTeacher: () => teacherInitialState,
  },
});

/* =====================================================
   STUDENT SLICE
===================================================== */

const studentInitialState = {
  data: null,
  loading: false,
  error: null,
  profileImage: null,
};

const studentSlice = createSlice({
  name: "student",
  initialState: studentInitialState,
  reducers: {
    setStudentData: (state, action) => {
      state.data = action.payload;
      state.profileImage = action.payload?.profileImage || null;
      state.loading = false;
    },
    setStudentLoading: (state) => {
      state.loading = true;
    },
    setStudentError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    setStudentProfileImage: (state, action) => {
      state.profileImage = action.payload;
      if (state.data) {
        state.data.profileImage = action.payload;
      }
    },
    clearStudent: () => studentInitialState,
  },
});

/* =====================================================
   STORE
===================================================== */

const store = configureStore({
  reducer: {
    login: loginSlice.reducer,
    teacher: teacherSlice.reducer,
    student: studentSlice.reducer,
  },
});

/* =====================================================
   EXPORTS (KEEP EXISTING API)
===================================================== */

// login
export const { loginSuccess, logout } = loginSlice.actions;

// teacher
export const {
  setTeacherData,
  setTeacherLoading,
  setTeacherError,
  setProfileImage,
  setCertificates,
  clearTeacher,
} = teacherSlice.actions;

// student
export const {
  setStudentData,
  setStudentLoading,
  setStudentError,
  setStudentProfileImage,
  clearStudent,
} = studentSlice.actions;

export default store;
